export default "__VITE_ASSET__e683c717__"